import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { FormsModule } from '@angular/forms';
import { TranslateModule } from "@ngx-translate/core";

import { MatMenuModule } from '@angular/material/menu';

import { LzHeaderComponent } from "./components/header/lz-header.component";
import { LzBurgerComponent } from './components/burger/burger.component';

@NgModule({
  declarations: [
    LzHeaderComponent,
    LzBurgerComponent
  ],
  providers: [],
  imports: [
    CommonModule,
    FormsModule,
    MatMenuModule,
    TranslateModule
  ],
  entryComponents: [
    LzHeaderComponent,
    LzBurgerComponent
  ],
  exports: [
    LzHeaderComponent
  ]
})

export class LzHeaderModule { }
